<template>
  <div>
    <div class="contents xpointlist">
      <b-form
        @submit="onSubmit"
        class="filter-group row row-cols-1 row-cols-xl-auto g-2"
      >
        <div class="col col-xl-2">
          <select aria-label="" v-model="searchData.pagesize">
            <option value="10" selected>
              {{ $t("filter.common.sort_by_10") }}
            </option>
            <option value="50">{{ $t("filter.common.sort_by_50") }}</option>
            <option value="100">
              {{ $t("filter.common.sort_by_100") }}
            </option>
          </select>
        </div>
        <div class="col col-xl-4">
          <div class="date-search">
            <input
              type="month"
              class="form-control-lg"
              v-model="searchData.startdate"
            />
            <input
              type="month"
              class="form-control-lg"
              v-model="searchData.enddate"
            />
          </div>
        </div>
        <div class="col col-xl-2">
          <select class="form-select" v-model="searchData.searchtype">
            <option value="O.nickname">
              {{ $t("filter.common.location") }}
            </option>
            <option value="CM.title">
              {{ $t("filter.common.course") }}
            </option>
          </select>
        </div>
        <div class="col col-xl-4">
          <div class="row g-2">
            <div class="col">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchData.searchname"
                />
                <button
                  class="btn btn-primary btn-lg icon-search"
                  type="submit"
                  value=""
                ></button>
              </div>
            </div>
          </div>
        </div>
      </b-form>
      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-xxl-table-cell">
              {{ $t("title.common.course") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell sortable" @click="toggleSort('playing_cnt_out_9')">
              {{ $t("title.admin.playing_cnt") }}(OUT 9H) {{ sortIcon('playing_cnt_out_9') }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell sortable" @click="toggleSort('playing_cnt_in_9')">
              {{ $t("title.admin.playing_cnt") }}(IN 9H) {{ sortIcon('playing_cnt_in_9') }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell sortable" @click="toggleSort('playing_cnt_18')">
              {{ $t("title.admin.playing_cnt") }}(18H) {{ sortIcon('playing_cnt_18') }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell sortable" @click="toggleSort('playing_cnt')">
              {{ $t("title.admin.playing_cnt") }} {{ sortIcon('playing_cnt') }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="items.length > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xxl-table-cell w-1">
                {{ index + 1 + (searchData.pageno - 1) * searchData.pagesize }}
              </td>
              <td class="col-auto d-xxl-table-cell">
                {{ item.coursename }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.shopname }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{ item.playing_cnt_out_9 | comma }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.playing_cnt_in_9 | comma }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.playing_cnt_18 | comma }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.playing_cnt | comma }}
              </td>

              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">
                      {{
                        index +
                        1 +
                        (searchData.pageno - 1) * searchData.pagesize
                      }}
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.location") }}
                    </div>
                    <div class="col-8">
                      {{ item.shopname }}
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.admin.playing_cnt") }}(OUT 9H)
                    </div>
                    <div class="col-8">
                      {{ item.playing_cnt_out_9 | comma }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.playing_cnt") }}(IN 9H)
                    </div>
                    <div class="col-8">{{ item.playing_cnt_in_9 | comma }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.playing_cnt") }}(18H)
                    </div>
                    <div class="col-8">
                      {{ item.playing_cnt_18 | comma }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.playing_cnt") }}
                    </div>
                    <div class="col-8">
                      {{ item.playing_cnt | comma }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="Math.ceil(totalCnt / searchData.pagesize)"
        v-model="searchData.pageno"
        use-router
        v-if="totalCnt > 0"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/stats";

export default {
  name: "CourseStats",
  data() {
    return {
      searchData: {
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          10,
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs().add(-1, "month").format("YYYY-MM"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs().format("YYYY-MM"),
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "O.nickname",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        orderby: "playing_cnt",
        order: "DESC",
      },
      totalCnt: 0,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.getStats();
    },
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.getStats();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.getStats();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.getStats();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.getStats();
    },
    "searchData.pageno": function () {
      this.getStats();
    },
  },
  created() {
    this.getStats();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.getStats();
    },

    toggleSort(field) {
      if (this.searchData.orderby === field) {
        this.searchData.order = this.searchData.order === "DESC" ? "ASC" : "DESC";
      } else {
        this.searchData.orderby = field;
        this.searchData.order = "DESC";
      }
      this.searchData.pageno = 1;
      this.getStats();
    },

    sortIcon(field) {
      if (this.searchData.orderby !== field) return "↕";
      return this.searchData.order === "DESC" ? "↓" : "↑";
    },

    getStats() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_coursestats(this.searchData, (flag, data) => {
        if (flag) {
          this.items = data.coursestats;
          this.totalCnt = data.listcnt;
        } else {
          alert(data.message);
        }
      });
    },

    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },

    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
<style scoped>
.sortable {
  cursor: pointer;
  user-select: none;
}
.sortable:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>